import {Base_URL} from "../url";
import axios from "axios";

export const getBRBDDocuments = async () => {
  const res = await axios.get(`${Base_URL}/BRBD/getDocumentsBRBD`);
  return res.data;
};

export const getBRBDDirectors = async (orgId) => {
  const res = await axios.get(`${Base_URL}/BRBD/getDirectorsBRBD/${orgId}`);
  return res.data;
};

export const getBRBDProperties = async (orgId) => {
    const res=await axios.get(`${Base_URL}/RentPayable/GetPropertyData/${orgId}`);
    return res.data;
}

export const getBRBDResources = async (orgId) => {
  const res=await axios.get(`${Base_URL}/BRBD/GetResources/${orgId}`);
  return res.data;
}